import styled, { css } from "styled-components";
import { boxshadowMediumStyle } from "../../styles/utils/Dropshadows.styles";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const HORIZONTAL_MENU_HEIGHT = 46; // Height of the HorizontalMenu on desktop
export const BREADCRUMBS_HEIGHT = 52; // Height breadcrumb navigation
export const ARROW_WIDTH = 20;
export const EXTRA_SCROLL_MARGIN = 24; // Randomly selected extra 24px padding so the title doesn't stick to the navigation. On mobile this is divided by 2.
export const EXTRA_DETECTION_MARGIN = 24 + 32; // Set a nav item as active a little bit earlier, for example when rendering beneath status bars on iOS (32px)

export const Wrapper = styled.nav<{ sticky: boolean }>`
    display: none;
    column-gap: var(--spacing-1);
    position: sticky;
    top: calc(var(--visibleHeaderHeight) + ${BREADCRUMBS_HEIGHT}px);
    align-items: center;
    margin-block: var(--spacing-3);
    margin-inline: calc(var(--spacing-3) * -1);
    padding-inline: var(--spacing-3);
    background-color: var(--color-grey-1);
    z-index: var(--z-index-sticky);

    ${({ sticky }) =>
        sticky &&
        css`
            margin-block-end: 0;
            padding-block-end: var(--spacing-2);
        `};

    @media screen and (min-width: ${breakpoints.xl}) {
        display: block;
    }

    @media screen and (min-width: ${breakpoints.xxl}) {
        margin-inline: calc(var(--spacing-7) * -1);
        padding-inline: var(--spacing-7);
    }

    @supports not (margin-block: 0) {
        margin-top: var(--spacing-3);
        margin-bottom: var(--spacing-3);
        margin-left: calc(var(--spacing-3) * -1);
        margin-right: calc(var(--spacing-3) * -1);
        padding-left: var(--spacing-3);
        padding-right: var(--spacing-3);

        @media screen and (min-width: ${breakpoints.xxl}) {
            margin-left: calc(var(--spacing-7) * -1);
            margin-right: calc(var(--spacing-7) * -1);
            padding-left: var(--spacing-7);
            padding-right: var(--spacing-7);
        }
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    height: 46px;
    background-color: var(--color-grey-4);

    &::after,
    &::before {
        display: block;
        position: absolute;
        width: 20px;
        height: 46px;
        z-index: 1000;
    }

    &[data-alignment="left"] {
        padding-left: calc(var(--spacing-3) / 2);
        &::after {
            right: -20px;
            content: "";
            background: linear-gradient(90deg, var(--color-grey-4) 1.29%, rgba(228, 228, 228, 0) 95.49%);
        }
    }

    &[data-alignment="right"] {
        padding-right: calc(var(--spacing-3) / 2);
        &::before {
            left: -20px;
            content: "";
            background: linear-gradient(268deg, var(--color-grey-4) 1.29%, rgba(228, 228, 228, 0) 95.49%);
        }
    }

    &[hidden] {
        display: none;
    }
`;

export const Button = styled.button`
    display: flex;
    margin: 0 calc(var(--spacing-1) / 2);
    padding: calc(var(--spacing-1) / 4);
    background-color: var(--color-primary-white);
    border-radius: 3px;
`;

export const MenuListContainer = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
`;

export const MenuList = styled.ul`
    display: flex;
    position: relative;
    flex-grow: 1;
    align-items: center;
    margin: 0;
    padding: calc(var(--spacing-3) / 4);
    list-style: none;
    background-color: var(--color-grey-4);
    border-radius: 8px;
    overflow-x: auto;
`;

export const MenuListItem = styled.li`
    display: flex;
    position: relative;
    flex: 1 0 auto;
    align-items: center;
    justify-content: center;

    &:not(:last-of-type) {
        &::after {
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 20px;
            content: "";
            border-inline-end: 1px solid var(--color-grey-6);
            transform: translateY(-50%);
        }
    }

    &[aria-current="location"] {
        box-shadow: 0 0 0 1px var(--color-grey-4);
        &::after {
            display: none;
        }
    }
`;

export const MenuLink = styled.a`
    display: flex;
    position: relative;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: calc(var(--spacing-3) / 4) var(--spacing-2) var(--spacing-1) var(--spacing-2);
    font-family: var(--font-semi-bold);
    font-size: 1.3rem;
    line-height: 2rem;
    color: var(--color-primary-dark);

    &[aria-current="location"] {
        background-color: var(--color-primary-white);
        border-radius: 4px;
        ${boxshadowMediumStyle};
    }
`;
